import * as React from 'react';
import {
    Card, TextField, CardContent, Box, IconButton, Grid, 
    Typography, Popover, Slider, useTheme, Skeleton, Button, Stack,
    useMediaQuery,
    Divider,
    Chip,
    alpha
  } from '@mui/material'

import PercentageCard from './PercentageCard';
import {disp_rank, disp_rank_short} from 'assets/utils';
import Donut from 'components/Donut';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import StarIcon from '@mui/icons-material/Star';

import { Bar, Line } from 'react-chartjs-2';
import { Adsense } from '@ctrl/react-adsense';
import { useAddFavorite, indexOf, useFavorites, useRemoveFavorite } from 'assets/favorites';
import { useLocation, useSearchParams } from 'react-router-dom';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import SeasonBar from 'components/SeasonBar';
import { next_rank, prev_rank } from 'assets/utils';
import { RankLabel } from 'components/PercentageBar2';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import Statistics from './Statistics';
import AdComponent from 'components/AdComponent';
import ActivityCard from './ActivityCard';
import RecentActivityCard from './RecentActivityCard';
import PageWrapperBox from 'components/PageWrapperBox';

import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { Ticks } from 'chart.js';
import DisclaimerBox from 'components/DisclaimerBox';
import InfoBox from 'components/InfoBox';
import ShadowBox from 'components/ShadowBox';
import OutlinedBox from 'components/OutlinedBox';
import { useTranslation, Trans } from "react-i18next";

function getRankingNr(data) {
    if (data["leaderboard"] && data["singles"]["current_rank"] >= 95) {
        for (var i = 0; i<data["leaderboard"].length; ++i) {
            let record = data["leaderboard"][i]
            if (record["leaderboard"] == "singles_rm" && data["singles"]["sub_category"] == "M") {
                return record["rank"]
            } else if (record["leaderboard"] == "singles_rv" && data["singles"]["sub_category"] == "V") {
                return record["rank"]
            }
        }
    }

    return null;
}


export default ({data, sx, canSelectSeason}) => {

    const { t } = useTranslation();
    const isLoading = data === null;
    
    const navigate = (url) => {
        window.location.href = url;
    }

    const [value, setValue] = React.useState(0);

    const navigateToUser = () => {
      if (isLoading) {
        return;
      }

      console.log(data)

      if (data["tvlid"]) {
        navigate('https://www.tennisenpadelvlaanderen.be/nl/dashboard/resultaten?userId=' + data.tvlid);
      } else if (data["membernr"]) {
        navigate('https://tennis.tppwb.be/MyAFT/Players/Detail/' + data.membernr);
      }
    }

    const rankStr = isLoading ? null : (data?.rank ? disp_rank(data["rank"], data["cat"]) : null);

    return <>

        <PageWrapperBox sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
        }}>

            <Box>
            <Typography variant="body" fontSize={18} fontWeight="bold" color="primary" component="div"  sx={{cursor: "pointer", lineHeight: "1.4em"}} onClick={navigateToUser}>
            {isLoading ? <Skeleton width="50%"/> : data["name"]}
            </Typography>
            <Typography variant="caption" component="div" color="#777" sx={{lineHeight: "1.4em", pt: 0.25}}>
            {rankStr && <b style={{marginRight: "4px"}}>{rankStr.replace(" ", "\u00A0")} •</b>}{isLoading ? <Skeleton width="50%"/> : data["club"]}
            </Typography>

            </Box>
            
            {isLoading ? null: <FavoriteButton playerId={data["player_id"]} name={data["name"]} club={data["club"]}/>}

            </PageWrapperBox>

            <Box sx={{marginTop: '30px', paddingTop: 3, marginBottom: '30px', width: "100%"}}>
            <AdComponent/>
        </Box>

      <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" id="overview">
          {t("userCard.overview")}
      </Typography>

    {/*<Typography variant="body" component="div" color="text.primary_bold">
            Huidig enkelklassement: <Typography variant="body" sx={{fontWeight: "bold"}} color="primary">{disp_rank(single, single_sub)} {rankingnr ? "nr. " + rankingnr : ""}</Typography>
        </Typography>

        <Typography variant="body" component="div" color="text.primary_bold">
            Huidig dubbelklassement: <Typography variant="body" sx={{fontWeight: "bold"}} color="primary">{disp_rank(double, double_sub)}</Typography>
        </Typography>*/}

        
        
        <Box display="flex" justifyContent="center">
        <SeasonSelector canSelectSeason={canSelectSeason}/>
        </Box>

        {!isLoading? ((data?.singles || data?.doubles) ? <OtherData data={data} canSelectSeason={canSelectSeason}/> : <NoCalculation/>) : null}
        
       
            {/*<RoundChart/>*/}
    </>
}

function NoCalculation() {
  const { t } = useTranslation();

  return <OutlinedBox sx={{py: 1, px: 1, mt: 1, fontStyle: "italic", textAlign: "center"}}>
        <Typography variant="body2" color="text.secondary">
        {t("userCard.noData")}
        </Typography>
      </OutlinedBox>
}

export function FavoriteButton({playerId, name, club, color}) {

    const favorites = useFavorites();

    const [favorite, setFavorite] = React.useState(indexOf(favorites, playerId) >= 0);
    const addFavorite = useAddFavorite();
    const removeFavorite = useRemoveFavorite();

    React.useEffect(() => {
        setFavorite(indexOf(favorites, playerId) >= 0)
    }, [playerId])

    const toggleFavorite = () => {
        setFavorite(!favorite)
        if (favorite) {
            removeFavorite(playerId)
        } else {
            addFavorite({playerId: playerId, name: name, club: club})
        }
        
    }

    const theme = useTheme();

    return <IconButton display="flex" onClick={toggleFavorite}>
        {favorite ? <StarIcon style={{color: color || theme.palette.primary.main}} fontSize='medium'/> : <StarOutlineIcon style={{color: color || theme.palette.primary.main}} fontSize='medium'/>}
    </IconButton>
}

function OtherData({data,canSelectSeason}) {
    const { t } = useTranslation();
    const single=data["singles"]["current_rank"]
    const single_pred=data["singles"]["predicted_rank"]
    const single_sub=data["singles"]["sub_category"]
    const single_elo_rank=data["singles"]["elo_rank"]

    const double=data["doubles"]["current_rank"]
    const double_pred=data["doubles"]["predicted_rank"]
    const double_sub=data["doubles"]["sub_category"]
    const double_elo_rank=data["doubles"]["elo_rank"]

    const rankingnr = getRankingNr(data);

    const minRank = single_sub.length > 1 ? 1 : 3;
    const maxRank = single_sub.length > 1 ? 30 : 115;

    const firstMark = Math.max(minRank, prev_rank(single, single_sub.length == 1));
    const lastMark = Math.min(Math.max(next_rank(next_rank(next_rank(single))), next_rank(single_pred), double, next_rank(double_pred)), maxRank);

    const theme = useTheme();

    return <> 

        

        <PredictionCard
          rank={single}
          sub={single_sub}
          predRank={single_pred}
          eloRank={single_elo_rank}
          label={t("common.singlesLower")}
          isSingles={true}
          rankData={data["singles"]}
          firstMark={firstMark}
          lastMark={lastMark}
        />

        <PredictionCard
          rank={double}
          sub={double_sub}
          predRank={double_pred}
          eloRank={double_elo_rank}
          label={t("common.doublesLower")}
          isSingles={false}
          rankData={data["doubles"]}
          firstMark={firstMark}
          lastMark={lastMark}
        />

        <InfoBox title={t("userCard.playStrengthTitle")} backgroundColor="#F6FBFF" color={theme.palette.primary.main} titleColor={theme.palette.primary.dark}>
          <Trans i18nKey="userCard.playStrengthBody" components={{ b: <b style={{color: theme.palette.primary.dark}} /> }} />
        </InfoBox>

        <DisclaimerBox/>

        {/*<Grid container>
            <Grid item xs={12} sm={6} sx={{display: "flex", alignContent: "center", justifyContent: "center", pt: 2}}>
                <Donut won={data["singles"]["nw"]} lost={data["singles"]["nm"] - data["singles"]["nw"]} name="Enkel"/>
            </Grid>
            <Grid item xs={12} sm={6} sx={{display: "flex", alignContent: "center", justifyContent: "center", pt: 2}}>
                <Donut won={data["doubles"]["nw"]} lost={data["doubles"]["nm"] - data["doubles"]["nw"]} name="Dubbel"/>
            </Grid>
        </Grid> */}

        <Statistics data={data}/>

        {data.history.length > 0 ? <>
          <PreviousRankingsChart history={data["history"]}/>
          <PreviousRankingsChartAlt data={data}/>
        </> : null}

        <Box sx={{marginTop: '30px', paddingTop: 3, marginBottom: '30px', width: "100%"}}>
            <AdComponent/>
        </Box>

        {data.activity && <ActivityCard activity={data["activity"]} name={data["name"]} name_club={data["club"]} rankSingles={single} rankDoubles={double}/>}
        
        {data.activity_recent?.singles?.length > 0 || data.activity_recent?.doubles?.length > 0 ? <>
        <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" mt={6} mb={2}>
        {t("userCard.recentMatches")}
        </Typography>
        <RecentActivityCard activity={data["activity_recent"]} name={data["name"]} name_club={data["club"]} rankSingles={single} rankDoubles={double} />
        </> : null}
    </>
}

function RoundChart() {
    const theme = useTheme()
    const options = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: "bottom"
          }
        },
        interaction: {
          intersect: false,
          mode: 'index',
        },
        scales: {
          y: {
              maxRotation: 0,
            display: false
          },
          x: {
            grid: {
              display: false,
            },
            //ticks: {
            //  maxRotation: 0
            //}
          }
        },
      };
      
    const chartData = {
        labels: ["1/8e finale", "1/4e finale", "1/2e finale", "finale", "finalewinst"],
        datasets: [
        {
            label: "Enkel",
            data: [30, 20, 10, 1],
            backgroundColor: theme.palette.primary.main,
            borderRadius: 5,
        },
        {
            label: "Dubbel",
            data: [30, 20, 10, 1],
            backgroundColor: '#d8e7f2',
            borderRadius: 5,
        },
        ],
    
    };
          
    return <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", pt: 2}}>
        <Bar options={options} data={chartData} />
    </Box>;
}

function SeasonSelector({canSelectSeason}) {
    const { t } = useTranslation();

    const seasons = [
        {tag: "dec2022", label: t("seasons.winter", {year: 2023}), start: 2022.5},
        {tag: "jun2023", label: t("seasons.summer", {year: 2023}), start: 2023},
        {tag: "oct2023", label: t("seasons.winter", {year: 2024}), start: 2023.5},
        {tag: "may2024", label: t("seasons.summer", {year: 2024}), start: 2024},
        {tag: "oct2024", label: t("seasons.winter", {year: 2025}), start: 2024.5},
        {tag: "may2025", label: t("seasons.summer", {year: 2025}), start: 2025},
        {tag: "oct2025", label: t("seasons.winter", {year: 2026}), start: 2025.5},
        {tag: "may2026", label: t("seasons.summer", {year: 2026}), start: 2026},
        {tag: "oct2026", label: t("seasons.winter", {year: 2027}), start: 2026.5},
    ]
    
    const [searchParams, setSearchParams] = useSearchParams();
    const [selected, setSelected] = React.useState(seasons.length - 1);

    React.useEffect(() => {
        const s = searchParams.get("s")

        if (s) {
            var ind = seasons.length - 1;
            for (var i = 0; i < seasons.length; ++i) {
                if (seasons[i].tag == s) {
                    ind = i;
                    break
                }
            }
            setSelected(ind)
        } else {
            setSelected(seasons.length - 1)
        }
    }, [searchParams])

    const select = (i) => {
        if (canSelectSeason()) {
            const newIndex = Math.min(Math.max(i, 0), seasons.length - 1);
            setSearchParams({s: seasons[newIndex].tag})
        }
        
    }

    const marksFrom = 2022.5;
    const marksTo = 2027.5;
    
    const marks = [
        {value: 2023, label: "2023"},
        {value: 2023.5, label: null},
        {value: 2024, label: "2024"},
        {value: 2024.5, label: null},
        {value: 2025, label: "2025"},
        {value: 2025.5, label: null},
        {value: 2026, label: "2026"},
        {value: 2026.5, label: null},
        {value: 2027, label: "2027"},
    ]

    return <ShadowBox sx={{width: "100%", display: "flex", flexDirection: "column", p: 2, pb: 0.5, mt: 2}}>
      <Box sx={{width: "90%", alignSelf: "center", flexGrow: 1, display: "flex", flexDirection: "column"}}>
        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

        <Button
            size="small"
            onClick={() => select(selected - 1)}
            style={{visibility: selected == 0 ? 'hidden' : 'visible'}}
          >
            <KeyboardArrowLeft /> 
          </Button>

        <Typography sx={{fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", userSelect: 'none'}} color="primary.main">
            {seasons[selected].label}
        </Typography>

        <Button
            size="small"
            onClick={() => select(selected + 1)}
            //disabled={selected == seasons.length - 1}
            style={{visibility: selected == seasons.length - 1 ? 'hidden' : 'visible'}}
          >
            <KeyboardArrowRight />
          </Button>
    </Box>
    <SeasonBar marks={marks} from={marksFrom} to={marksTo} selectedFrom={seasons[selected].start} selectedTo={seasons[selected].start+1}/>
    </Box>
    </ShadowBox>
}

function PreviousRankingsChartAlt({data}) {
  const history = data?.history;

    const { t, i18n } = useTranslation();
    const historyFiltered = React.useMemo(() => {
        const filtered = history.filter(el => !el.p);
        if (filtered.length == 0) {
            return history;
        }
        return filtered;
    }, [history])

    const theme = useTheme()
    const options = {
        responsive: true,
        aspectRatio: 2,
        plugins: {
          legend: {
            display: false,
            position: "bottom"
          },
          tooltip: {
            enabled: false,
          },
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.borderColor;
            },
            borderRadius: 4,
            color: 'white',
            font: {
              weight: 'bold'
            },
            formatter: Math.round,
            padding: 4
          }
        },
        interaction: {
          intersect: false,
          mode: 'index',
        },
        elements: {
          line: {
            fill: false,
            tension: 0.9
          }
        },
        scales: {
          y: {
            offset: false,
              maxRotation: 0,
              max: Math.ceil((historyFiltered.reduce((max, el) => Math.max(max, el.ss, el.ds), 0) + 10) / 20) * 20,
            grid: {
              display: true,
            },
            ticks: {
              display: false,
            },
            border: {
              display: false,
            },
            min: 0,
          },
          x: {
            offset: true,
            grid: {
              display: true,
            },
            //ticks: {
            //  maxRotation: 0
            //}
          }
        },
      };

    const [selected, setSelected] = React.useState(true);
    const [selected2, setSelected2] = React.useState(false);
      
    const chartData = {
        labels: historyFiltered.map(el => el["l"]),
        datasets: [
        {
            label: t("common.singles"),
            data: historyFiltered.map(el => selected ? el["ss"] : el["ds"]),
            backgroundColor: selected ? alpha(theme.palette.primary.main, 0.15) : alpha(theme.palette.primary.dark, 0.15),
            borderColor: selected ? theme.palette.primary.main : theme.palette.primary.dark,
            borderRadius: 5,
            //hidden: !selected,
            cubicInterpolationMode: 'monotone',
            datalabels: {
              color: "white",
            }
        },
        ],
    
    };

    const Row = ({value1, value2, value3, delta, title}) => (
       <Stack key={value1} sx={{justifyContent: "space-between", width: "100%", flexDirection: "row", alignItems: "center", px: 0.5, py: title ? 0 : 0.5}}>
        <Typography variant="caption" sx={{fontWeight: title ? "bold" : "normal", width: "30%", textTransform: title ? "uppercase" : "default", color: title ? "#777" : "text.primary_bold"}}>
          {value1}
        </Typography>
        <Typography variant="caption" sx={{width: "40%", fontWeight: title ? "bold" : "normal", pl: 1, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", textAlign: "center", textTransform: title ? "uppercase" : "default", color: title ? "#777" : "text.primary_bold"}}>
          {value2}
        </Typography>
        <Typography variant="caption" sx={{width: "30%", fontWeight: title ? "bold" : "normal", pl: 1, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", textTransform: title ? "uppercase" : "default", textAlign: "right", color: title ? "#777" : "text.primary_bold", display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
          {delta ? <><b style={{marginRight: "4px", fontSize: 8, display: "inline-block", color: delta > 0 ? theme.palette.primary.light : theme.palette.primary.dark}}>{delta > 0 ? "▲" : "▼"}</b>{value3}</> : value3}
        </Typography>
      </Stack>
    )

    const md = useMediaQuery((theme) => theme.breakpoints.up('md'));

    const recentStrength = selected ? data?.singles_strength : data?.doubles_strength;
    const mapDate = (str) => {
        var d = new Date(str);
        const today = new Date();

        if (d > today) {
            d = today;
        }
        return d.toLocaleDateString(i18n.language, {day: 'numeric', month: 'short', year: 'numeric'})
    }
          
    return <ShadowBox sx={{display: "flex", flexDirection: "column", alignItems: "center", mt: 1}}>
        <Typography variant="body1" fontWeight="bold" sx={{borderBottom: "1px solid", borderColor: "divider", py: 1, pl: 1.5, alignSelf: "flex-start", width: "100%"}} color="text.primary_bold" component="div">
        {t("userCard.playStrengthChartTitle")}
        </Typography>

        <Box sx={{px: md ? 4 : 2, width: "100%", mt: 3, mb: 2}}>
        <Line options={options} data={chartData} plugins={[ChartDataLabels]} />
        </Box>

        {recentStrength && recentStrength.length > 0 ? <Box sx={{width: "calc(100% - 32px)", mx: 2, mb: 1, mt: 0.5}}>
          <Row title value1={t("common.date")} value2={t("speler.sections.wins")} value3={t("h2h.playStrengthShort")}/>
          <Divider sx={{width: "100%"}}/>
          {recentStrength.map((el, index) => {
              const previousStrength =
                index > 0
                  ? recentStrength[index - 1].glicko_pts
                  : null;

              const delta =
                previousStrength !== null
                  ? el.glicko_pts - previousStrength
                  : null;

              return (
                <Row
                  key={el.date}
                  value1={mapDate(el.date)}
                  value2={`${el.n_wins_delta}/${el.n_matches_delta}`}
                  value3={t("filters.rankValue", { points: el.glicko_pts })}
                  delta={delta}
                />
              );
            })}
        </Box> : null}

        <Box
            sx={{
              display: "flex",
              alignItems: "center",

              p: "3px",
              mb: 1.5,
              mt: 1,
              gap: 0.5,

              borderRadius: 2,
              backgroundColor: theme.palette.action.hover,
            }}
          >
            <PreviousRankingsChartButton
              label={t("common.singles")}
              color={theme.palette.primary.main}
              selected={selected}
              onClick={() => setSelected(true)}
            />

            <PreviousRankingsChartButton
              label={t("common.doubles")}
              color={theme.palette.primary.dark}
              selected={!selected}
              onClick={() => setSelected(false)}
            />
          </Box>
    </ShadowBox>;
}

function PreviousRankingsChartButton({
  label,
  selected,
  onClick,
  color,
}) {

  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        minWidth: 72,
        height: 30,
        px: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 1.5,
        backgroundColor: selected
          ? color
          : "transparent",
        color: selected
          ? theme.palette.common.white
          : theme.palette.text.secondary,
        fontSize: 12,
        fontWeight: selected ? 600 : 500,
        lineHeight: 1,
        cursor: "pointer",
        userSelect: "none",
        transition: theme.transitions.create(
          ["background-color", "color", "box-shadow", "transform"],
          {
            duration: 150,
          }
        ),
        boxShadow: selected
          ? `0 1px 3px ${alpha(color, 0.25)}`
          : "none",
        "&:hover": {
          backgroundColor: selected
            ? color
            : alpha(theme.palette.text.primary, 0.05),
        },
        "&:active": {
          transform: "scale(0.98)",
        },
      }}
    >
      {label}
    </Box>
  );
}

function PreviousRankingsChart({history}) {
    const { t } = useTranslation();
    const theme = useTheme()
    const options = {
        responsive: true,
        aspectRatio: 1.5,
        layout: {
            padding: {
                top: 0, // Adjust this value to add more or less padding to the top
                right: 2,
                bottom: 0,
                left: 2
            }
        },
        plugins: {
          legend: {
            display: false,
            position: "bottom"
          },
           tooltip: {
            enabled: false,
          },
          datalabels: {
            align: 'end',
            anchor: 'end',
            font: {
                weight: 'bold'
            },
            offset: -2,
          }
        },
        interaction: {
          intersect: false,
          mode: 'index',
        },
        scales: {
          y: {
              maxRotation: 0,
              max: Math.ceil((history.reduce((max, el) => Math.max(max, el.s, el.d), 0) + 10) / 20) * 20,
            display: false
          },
          x: {
            grid: {
              display: true,
            },
            //ticks: {
            //  maxRotation: 0
            //}
          }
        },
      };

    const [selected, setSelected] = React.useState(true);
      
    const chartData = {
        labels: history.map(el => el["l"]),
        datasets: [
        {
            label: t("userCard.rankingChartLabel"),
            data: history.map(el => selected ? el["s"] : el["d"]),
            backgroundColor: history.map(el => selected ? (el["p"] ? '#96cefa' : theme.palette.primary.main) : (el["p"] ? '#6d95bf' : theme.palette.primary.dark)),
            borderRadius: 5,
            datalabels: {
              color: history.map(el => selected ? (el["p"] ? '#96cefa' : theme.palette.primary.main) : (el["p"] ? '#6d95bf' : theme.palette.primary.dark)),
            }
        },
        ],
    
    };

    const md = useMediaQuery((theme) => theme.breakpoints.up('md'));
          
    return <ShadowBox sx={{display: "flex", flexDirection: "column", alignItems: "center", mt: 1}}>
        <Typography variant="body1" fontWeight="bold" sx={{borderBottom: "1px solid", borderColor: "divider", py: 1, pl: 1.5, alignSelf: "flex-start", width: "100%"}} color="text.primary_bold" component="div">
        {t("userCard.rankingsChartTitle")}
        </Typography>

        <Box sx={{px: md ? 4 : 2, width: "100%", pb: 1, mt: 4}}>
        <Bar options={options} data={chartData} plugins={[ChartDataLabels]} />
        </Box>

        <Box
            sx={{
              display: "flex",
              alignItems: "center",

              p: "3px",
              mb: 1.5,
              gap: 0.5,

              borderRadius: 2,
              backgroundColor: theme.palette.action.hover,
            }}
          >
            <PreviousRankingsChartButton
              label={t("common.singles")}
              color={theme.palette.primary.main}
              selected={selected}
              onClick={() => setSelected(true)}
            />

            <PreviousRankingsChartButton
              label={t("common.doubles")}
              color={theme.palette.primary.dark}
              selected={!selected}
              onClick={() => setSelected(false)}
            />
          </Box>
    </ShadowBox>;
}

function PredictionCardRankingItem({rank, sub, label, color, trend = null}) {
  const theme = useTheme();
  const { t } = useTranslation();

  const unit = t("common.pts");
  const rankStr = disp_rank_short(rank, sub);
  const ptsStr = rankStr.replace(' ' + unit, '');
  const ptnStr = rankStr.includes(unit) ? unit : '';

  return <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", flex: "1 1 0", minWidth: 0}}>
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            align="center"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {label}
          </Typography>
                    <Typography variant="h5" component="div" color={color || theme.palette.primary.dark} align="center" sx={{fontWeight: "bold"}}>
                      {trend == "up" && <TrendingUpIcon style={{backgroundColor: theme.palette.primary.main, borderRadius: "5px", fontSize: 18, padding: "2px", marginRight: '5px', color: "white"}}/>}
                      {trend == "down" && <TrendingDownIcon style={{backgroundColor: theme.palette.primary.dark, borderRadius: "5px", fontSize: 18, padding: "2px", marginRight: '5px', color: "white"}}/>}

                      {ptsStr}<b style={{fontSize: 16, color: color || theme.palette.primary.dark, marginLeft: "4px"}}>{ptnStr}</b>
                    </Typography>

                    
          
  </Box>
}

export function PredictionCard({rank, predRank, eloRank, sub, label, isSingles, firstMark, lastMark, rankData, title}) {
  const theme = useTheme();
  const { t } = useTranslation();
  
  return <ShadowBox sx={{mt: 1, pt: 1.5}}>
        <Typography variant="body1" component="div" fontWeight="bold" color="text.primary_bold" sx={{ml: 1.5, textTransform: "capitalize"}}>
            {title || t("prediction.title", {type: label})}
        </Typography>
        <Typography variant="caption" component="div" color="text.secondary" sx={{mb: 2, ml: 1.5}}>
            {t("prediction.score", {score: rankData ? rankData["score"] : ""})}
        </Typography>
        <Stack sx={{flexDirection: "row", gap: 1, mb: 2, px: 1}}>
          <PredictionCardRankingItem rank={rank} sub={sub} label={t("prediction.current")}/>
          <Divider orientation="vertical" flexItem />
          <PredictionCardRankingItem rank={predRank} color={predRank <= rank ? theme.palette.primary.dark : theme.palette.primary.main} sub={sub} label={isSingles ? t("prediction.predictedAsterisk") : t("prediction.predicted")} trend={predRank > rank ? "up" : predRank < rank ? "down" : null}/>
          <Divider orientation="vertical" flexItem />
          <PredictionCardRankingItem rank={Math.round(eloRank)} color={eloRank <= rank ? theme.palette.primary.dark : theme.palette.primary.main} sub={sub} label={t("prediction.playStrength")}/>
        </Stack>

        <Divider sx={{mb: 1}}/>

        <Box sx={{display: "flex", justifyContent: "center"}}>
            <PercentageCard data={rankData} firstMark={firstMark} lastMark={lastMark}/>
        </Box>
    </ShadowBox>
}